// JOBE-0044.10.2: DocumentKindsContext — route-level seam that lets the
// composer's TypeValuePopover and the TypeRailBlock share a single
// GET /api/documents/kinds fetch per route mount.
//
// Canonical tri-state shape (mirrors EntityTypesContext):
//   { status: 'loading' | 'ready' | 'error', kinds: DocumentKindRow[],
//     error: string | null, retry: () => void }
//
// `retry` matches the existing TypeRailBlock useDocumentKinds hook
// contract so consumers don't have to branch on "context vs. hook"
// for the retry surface.

import { createContext } from 'react';

// Default value matches the `loading` branch of the tri-state. Used by
// useContext readers that render outside the provider (test harnesses
// that mount TypeRailBlock or TypeValuePopover in isolation). Identity-
// comparable so consumers can detect "no provider on the tree" and
// fall back to a local fetch.
export const DOCUMENT_KINDS_INITIAL = Object.freeze({
  status: 'loading',
  kinds: [],
  error: null,
  retry: () => {},
});

export const DocumentKindsContext = createContext(DOCUMENT_KINDS_INITIAL);
